export const RESEARCH_DATA = [
  {
    title: "Problem Statement",
    detail:
      "Often, people get stuck in case of a vehicular breakdown without assistance and are reluctant to ask strangers for help in unknown places. Thus, they are trapped until they find a mechanic who charges more than usual.",
  },
  {
    title: "Solution Statement",
    detail:
      "A mobile-based online application to provide hassle-free and real-time service to the user. App to be designed “Keeping budget, waiting time & quality in mind”.",
  },
];
export const UI_TYPOGRAPHY_DATA = [
  {
    head: "H1",
    size: "24px",
    fontsize: "31.6564px",
  },
  {
    head: "H2",
    size: "18px",
    fontsize: "23.66px",
  },
  {
    head: "H3",
    size: "16px",
    fontsize: "20.66px",
  },
  {
    head: "H4",
    size: "10px",
    fontsize: "15.66px",
  },
];
export const UI_COMPONENTS_DATA = [
  {
    id: 1,
    src: "/assets/case-study/roaddy/ui-component-1.webp",
    alt: "UI component showing a nearby service center on the Google Map",
  },
  {
    id: 2,
    src: "/assets/case-study/roaddy/ui-component-2.webp",
    alt: "UI component showing a nearby service center with address and open times for two wheeler service app",
  },
  {
    id: 3,
    src: "/assets/case-study/roaddy/ui-component-3.webp",
    alt: "UI component showing a nearby service center for two wheeler service app",
  },
];
export const OTHER_DESIGN_DATA = [
  {
    id: 1,
    src: "/assets/case-study/roaddy/other-screen-1.webp",
    alt: "Roaddy, a service app showing About page on app",
  },
  {
    id: 2,
    src: "/assets/case-study/roaddy/other-screen-2.webp",
    alt: "Payment screen on service app",
  },
  {
    id: 3,
    src: "/assets/case-study/roaddy/other-screen-3.webp",
    alt: "Filter option on Roaddy app",
  },
  {
    id: 4,
    src: "/assets/case-study/roaddy/other-screen-4.webp",
    alt: "Select Location screen  on  Roaddy app",
  },
  {
    id: 5,
    src: "/assets/case-study/roaddy/other-screen-5.webp",
    alt: "Refer a friend option on Roaddy app",
  },
  {
    id: 6,
    src: "/assets/case-study/roaddy/other-screen-6.webp",
    alt: "Screenshot showing service history, done on Roaddy app",
  },
  {
    id: 7,
    src: "/assets/case-study/roaddy/other-screen-7.webp",
    alt: "Screenshot showing a nearby service center",
  },
  {
    id: 8,
    src: "/assets/case-study/roaddy/other-screen-8.webp",
    alt: "User profile menu on app",
  },
  {
    id: 9,
    src: "/assets/case-study/roaddy/other-screen-9.webp",
    alt: "Option of payments including UPI, Online wallets on Roaddy app",
  },
];
export const COLOR_PALETTE_DATA = [
  "#2975BC",
  "#FFFFFF",
  "#F8F8F8",
  "#202020",
  "#929494",
];
export const ILLUSTRATIONS_IMAGES_DATA = [
  "/assets/case-study/roaddy/i-frame-1.webp",
  "/assets/case-study/roaddy/i-frame-2.webp",
  "/assets/case-study/roaddy/i-frame-3.webp",
  "/assets/case-study/roaddy/i-frame-4.webp",
  "/assets/case-study/roaddy/i-frame-5.webp",
];
export const BIG_CARD_DATA = [
  {
    img: "/assets/case-study/roaddy/model-g.webp",
    biodetails: [
      {
        que: "Name :",
        ans: "Deepti Singh",
      },
      {
        que: "Age :",
        ans: "21",
      },
      {
        que: "Location :",
        ans: "Delhi, India",
      },
      {
        que: "Occupation :",
        ans: "Student",
      },
      {
        que: "Marital status :",
        ans: "Unmarried",
      },
    ],
    motivation: [
      "Good service at budget price.",
      "Minimum response time.",
      "User friendly application interface.",
      "Assistance in secluded areas.",
    ],
    device: [
      {
        progresstitle: "Smart Phone",
        progressvalue: "80%",
      },
      {
        progresstitle: "Laptop",
        progressvalue: "40%",
      },
      {
        progresstitle: "Smart Watch",
        progressvalue: "65%",
      },
    ],
    interests: "Reading Books |  Cooking  |  Designing Websites",
    aboutme:
      "I am a graduate student who travels 15-20 km on an average daily as my college is located in the outskirts of a large city.",
    painpoints: [
      "Travel 20+ kms Da  ily on secluded roads.",
      "Hesitates to ask for help, introvert.",
      "Loses keys often.",
      "Careless about refueling and servicing.",
    ],
  },
  {
    img: "/assets/case-study/roaddy/model-b.webp",
    biodetails: [
      {
        que: "Name :",
        ans: "Varun Sharma",
      },
      {
        que: "Age :",
        ans: "32",
      },
      {
        que: "Location :",
        ans: "Bangalore, India",
      },
      {
        que: "Occupation :",
        ans: "Corp. Employee",
      },
      {
        que: "Marital status :",
        ans: "Unmarried",
      },
    ],
    motivation: [
      "Best quality at nominal price.",
      "Minimum response time.",
      "Service to remote areas.",
    ],
    device: [
      {
        progresstitle: "Smart Phone",
        progressvalue: "70%",
      },
      {
        progresstitle: "Laptop",
        progressvalue: "70%",
      },
      {
        progresstitle: "Smart Watch",
        progressvalue: "80%",
      },
    ],
    interests: "Swimming | Movies | Coding | Playing Cricket",
    aboutme:
      "I am a software engineer, working for an IT firm. I have to travel 30-40 kms daily on my two wheeler vehicle and on weekends, i prefer going to unexplored places.",
    painpoints: [
      "Busy schedule, no time for maintenance and servicing of vehicle.",
      "Reaching late to meetings.",
      "Can’t find quality service at a good price.",
    ],
  },
];
export const MOBILE_CHART_IMAGE_DATA = [
  {
    id: 1,
    width: 340,
    height: 187,
    src: "/assets/case-study/roaddy/chart-1.webp",
  },
  {
    id: 2,
    width: 344,
    height: 187,
    src: "/assets/case-study/roaddy/chart-2.webp",
  },
  {
    id: 3,
    width: 340,
    height: 187,
    src: "/assets/case-study/roaddy/chart-3.webp",
  },
  {
    id: 4,
    width: 340,
    height: 187,
    src: "/assets/case-study/roaddy/chart-4.webp",
  },
  {
    id: 5,
    width: 341,
    height: 406,
    src: "/assets/case-study/roaddy/chart-5.webp",
  },
  {
    id: 6,
    width: 341,
    height: 406,
    src: "/assets/case-study/roaddy/chart-6.webp",
  },
];
